import { Button } from 'primereact/button';
import { Chip } from 'primereact/chip';
// import { Tag } from 'primereact/tag';
import React from 'react';

import './trainingCard.css';

interface TrainingCardProps {
    metricName: string;
    courseName: string;
    skillName: string;
    behaviorName: string;
    assignedDate: string;
    trainingStatus: string;
    coachingToDoStatusId: number;
    coachingToDoStatus: string;
    onContinue: () => void;
}

const TrainingCard: React.FC<TrainingCardProps> = ({
    metricName,
    courseName,
    skillName,
    behaviorName,
    assignedDate,
    trainingStatus,
    coachingToDoStatusId,
    coachingToDoStatus,
    onContinue,
}) => {
    let backgroudColor = 'linear-gradient(#EB419E,#FC5858)';
    if (coachingToDoStatusId === 1) backgroudColor = 'linear-gradient(#0047FF, #52D5FF )';
    else if (coachingToDoStatusId === 2) backgroudColor = 'linear-gradient(#5FD714, #2BB753 )';
    return (
        <div className="card" style={{ padding: '.5rem' }}>
            <div className="CourseAssignment-div" style={{ background: backgroudColor }}>
                <p>
                    {metricName} - {courseName}
                </p>
                <p>
                    {skillName} - {behaviorName}
                </p>
            </div>
            <div
                className="card-body"
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
            >
                <Chip label={`Assigned: ${assignedDate}`} />
                {/* {coachingToDoStatusId === 4 && <Tag severity="danger" value="Help!" rounded />} */}
                <Button
                    label={coachingToDoStatusId === 1 ? 'Not Started' : coachingToDoStatus}
                    className="CourseAssignment-button"
                    style={{ background: coachingToDoStatusId === 4 ? 'red' : backgroudColor }}
                />
            </div>

            <Button
                label={trainingStatus}
                onClick={() => onContinue()}
                className="CourseAssignment-button"
                style={{ background: backgroudColor }}
            />
        </div>
    );
};

export default TrainingCard;
